<template>
  <div
    class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-products"
  >
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.product.artificialIntelligence.children.mensual.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.artificialIntelligence.subject')}/${$t('mEditionMenu.product.artificialIntelligence.children.mensual.subedition')}`"
        >
          {{ $t('mEditionMenu.product.artificialIntelligence.children.mensual.subtext') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.product.artificialIntelligence.children.creditos.subedition') === $route.params.subedition
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.artificialIntelligence.subject')}/${$t('mEditionMenu.product.artificialIntelligence.children.creditos.subedition')}`"
        >
          {{ $t('mEditionMenu.product.artificialIntelligence.children.creditos.subtext') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/*
 | Las dos pestañas de Inteligencia Artificial: el plan mensual (creditos que se renuevan el 1 de
 | cada mes) y el paquete de creditos (un solo pago, no vencen). Son dos satelites distintos, cada uno
 | con su columna en el producto.
 */
export default {
  name: 'MoleculeEditionProductArtificialIntelligenceSubMenu'
}
</script>
